import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Wrench, DollarSign, Calculator, Star, MapPin, Scale, Search } from 'lucide-react';

const allLinks = {
  repair: [
    { name: 'iPhone Repair', path: '/repair-iphone', icon: Wrench },
    { name: 'Samsung Repair', path: '/repair-samsung', icon: Wrench },
    { name: 'MacBook Repair', path: '/repair-macbook', icon: Wrench },
    { name: 'iPad Repair', path: '/repair-ipad', icon: Wrench },
    { name: 'Symptom Checker', path: '/symptom-checker', icon: Search },
    { name: 'Repair or Replace?', path: '/repair-or-replace-calculator', icon: Calculator },
    { name: 'vs Apple Store', path: '/repair-comparison/vs-apple-store', icon: Scale },
    { name: 'vs uBreakiFix', path: '/repair-comparison/vs-ubreakifix', icon: Scale },
    { name: 'iPhone Repair Cost', path: '/repair-cost/iphone-screen-repair-cost', icon: DollarSign },
    { name: 'Samsung Repair Cost', path: '/repair-cost/samsung-screen-repair-cost', icon: DollarSign },
    { name: 'MacBook Repair Cost', path: '/repair-cost/macbook-repair-cost', icon: DollarSign },
    { name: 'iPhone Repair Reviews', path: '/repair-reviews/iphone-repair-reviews', icon: Star },
  ],
  sell: [
    { name: 'Sell iPhone', path: '/sell-iphone', icon: DollarSign },
    { name: 'Sell Samsung', path: '/sell-samsung', icon: DollarSign },
    { name: 'Sell MacBook', path: '/sell-macbook', icon: DollarSign },
    { name: 'Sell or Keep Calculator', path: '/sell-or-keep-calculator', icon: Calculator },
    { name: 'Sell Multiple Devices', path: '/sell-multiple-devices', icon: DollarSign },
    { name: 'vs Apple Trade-In', path: '/sell-comparison/iphone-vs-apple-trade-in', icon: Scale },
    { name: 'vs Gazelle', path: '/sell-comparison/vs-gazelle', icon: Scale },
    { name: 'iPhone 16 Pro Max Value', path: '/how-much-is-my-worth/iphone-16-pro-max', icon: DollarSign },
  ],
  location: [
    { name: 'Repair in California', path: '/repair-in/california', icon: MapPin },
    { name: 'Repair in Texas', path: '/repair-in/texas', icon: MapPin },
    { name: 'Repair in Florida', path: '/repair-in/florida', icon: MapPin },
    { name: 'Repair in New York', path: '/repair-in/new-york', icon: MapPin },
    { name: 'Repair in Illinois', path: '/repair-in/illinois', icon: MapPin },
    { name: 'Sell in Chicago', path: '/sell-in/chicago', icon: MapPin },
    { name: 'Sell in New York', path: '/sell-in/new-york', icon: MapPin },
    { name: 'Sell in Los Angeles', path: '/sell-in/los-angeles', icon: MapPin },
  ],
};

const RelatedServices = ({ type = 'auto', maxItems = 6 }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Auto-detect which links to show based on current page
  let links = [];
  if (type === 'auto') {
    if (currentPath.includes('repair') || currentPath.includes('/repairs')) {
      links = [...allLinks.repair, ...allLinks.sell.slice(0, 3)];
    } else if (currentPath.includes('sell') || currentPath.includes('trade')) {
      links = [...allLinks.sell, ...allLinks.repair.slice(0, 3)];
    } else {
      links = [...allLinks.repair.slice(0, 4), ...allLinks.sell.slice(0, 4)];
    }
  } else {
    links = allLinks[type] || allLinks.repair;
  }

  // Filter out current page and limit
  const filtered = links.filter(l => l.path !== currentPath).slice(0, maxItems);

  if (filtered.length === 0) return null;

  return (
    <aside className="py-8 border-t border-slate-800" data-testid="related-services-widget">
      <div className="max-w-5xl mx-auto px-4">
        <h3 className="text-lg font-bold text-white mb-4">Related Services</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {filtered.map((link, i) => {
            const IconComp = link.icon;
            return (
              <Link
                key={i}
                to={link.path}
                className="flex items-center gap-2 bg-slate-900/40 border border-slate-800/50 rounded-lg px-3 py-2.5 hover:border-red-500/30 transition-colors group"
              >
                <IconComp className="w-4 h-4 text-red-400 flex-shrink-0" />
                <span className="text-slate-300 text-sm group-hover:text-white transition-colors truncate">{link.name}</span>
                <ChevronRight className="w-3 h-3 text-slate-600 ml-auto flex-shrink-0" />
              </Link>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default RelatedServices;
